import { render, staticRenderFns } from "./Modifiler.vue?vue&type=template&id=68e04d12&"
import script from "./Modifiler.vue?vue&type=script&lang=js&"
export * from "./Modifiler.vue?vue&type=script&lang=js&"
import style0 from "./Modifiler.vue?vue&type=style&index=0&id=68e04d12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QRadio,QCheckbox,QItemLabel});qInstall(component, 'directives', {Ripple});
